export default __webpack_public_path__ + "static/media/Rectangle 70.8db3f363.svg";